"use client";
import styles from "./HowToUseSideDrawer.module.scss";
import { cleanHtml } from "../../../utils/string/cleanHtml";
import { SEOFriendlyDrawer } from "../__shared__/SEOFriendlyDrawer/SEOFriendlyDrawer";
import { useState } from "react";
import { Trigger } from "../__shared__/Trigger/Trigger";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";
type Props = {
  howtoUseContent: string | null | undefined;
};

export const HowToUseSideDrawerUI = ({ howtoUseContent }: Props) => {
  const [open, setOpen] = useState(false);
  if (!howtoUseContent) return null;

  return (
    <>
      <Trigger
        label="How to use"
        onClick={withSideDrawerAnalytics("How To Use", () => setOpen(true))}
      />
      <SEOFriendlyDrawer
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
        heading={"How to use"}
        primaryButtonText="Close"
      >
        <div
          data-testid="howToUse:Description"
          className={styles.productDescriptionBody}
          dangerouslySetInnerHTML={{ __html: cleanHtml(howtoUseContent) || "" }}
        />
      </SEOFriendlyDrawer>
    </>
  );
};
